<div class="dialog-content">
  <div class="note" fxLayout="row wrap">
    <span class="text">
      Veuillez décrire votre besoin : désignation, Références, quantité
      demandée ou prix souhaité
    </span>
    <app-text-area-input
      [formControl]="message"
      row="5"
      label="Message"
    ></app-text-area-input>
  </div>

  <div *ngIf="!isVirtual">
    <h4>Mode de livraison</h4>

  <mat-radio-group
    [(ngModel)]="deliveryMode"
    class="delivery-radio-group custom-radio">

    <mat-radio-button
      value="DELIVERY_ADDRESS"
      class="delivery-option">

      <div class="option-content">
        <span class="option-title">
          LIVRAISON À L'ADRESSE DE LIVRAISON
        </span>
      </div>

    </mat-radio-button>

  </mat-radio-group>

  <!-- Bloc adresse -->
  <div *ngIf="deliveryMode === 'DELIVERY_ADDRESS'">
    <!-- Bloc adresse : visible SEULEMENT si "address" est choisi -->
      <div
        [ngClass]="isDefault ? 'address blink_me' : 'mini_address blink_me'"
        fxLayout="column"
        fxLayoutGap="32px"
      >
        <div class="text" fxLayout fxLayoutGap="16px">
          <span fxFlex="70">Adresse</span>
        </div>

        <mat-form-field appearance="outline" class="setPadding">
          <mat-select
            [(value)]="selectedAddress"
            (selectionChange)="initForm()"
            placeholder="Séléctionner une adresse"
          >
            <mat-option
              *ngFor="let address of clientAddresses"
              [value]="address"
              >{{
                address.addressTitle
                  ? address.addressTitle
                  : (address.contactName | slice: 0:7) +
                    ".." +
                    address.streetName
              }}</mat-option
            >
            <mat-option
              (click)="onAddAddressDialog()"
              fxLayout
              fxLayoutAlign="flex-start center"
            >
              <span>Ajouter une nouvelle adresse</span><span fxFlex></span
              ><img width="20" src="assets/icons/add-grey.svg" alt="Icone add-grey"/>
            </mat-option>
          </mat-select>
        </mat-form-field>

        <form
          [formGroup]="addAddressForm"
          (ngSubmit)="next()"
          *ngIf="selectedAddress"
          style="padding-top: 0 !important;"
        >
          <div fxLayout="column">
            <app-text-input
              [readOnly]="true"
              class=""
              formControlName="contactName"
              label="Société ou Nom et Prénom"
            ></app-text-input>
            <app-phone-input
              [readOnly]="true"
              formControlName="contactPhone"
              label="Téléphone"
            ></app-phone-input>
            <app-text-input
              [readOnly]="true"
              class=""
              formControlName="streetName"
              label="Adresse"
            ></app-text-input>

            <div fxLayout fxLayoutGap="16px">
              <app-text-input
                [readOnly]="true"
                [disabled]="true"
                class=""
                formControlName="city"
                label="Ville"
                fxFlex=""
              ></app-text-input>
              <app-text-input
                [readOnly]="true"
                class=""
                formControlName="postalCode"
                label="Code postal"
                fxFlex=""
              ></app-text-input>
            </div>

            <div fxLayout fxLayoutGap="16px">
              <app-text-input
                [readOnly]="true"
                class=""
                formControlName="cedex"
                label="Cedex"
                fxFlex=""
              ></app-text-input>
              <app-text-input
                [readOnly]="true"
                class=""
                formControlName="country"
                label="Pays"
                fxFlex=""
                [matAutocomplete]="country"
                [postIcon]="'assets/icons/arrow_drop_down.svg'"
              ></app-text-input>
              <mat-autocomplete #country="matAutocomplete">
                <mat-option
                  *ngFor="let country of countries$ | async"
                  [value]="country.name"
                >
                  {{ country.name }}
                </mat-option>
              </mat-autocomplete>
            </div>
          </div>
          <br />
        </form>
      </div>
    </div>
    <div class="pickup-separator">

        <div class="line"></div>

        <span>
            Ou 
        </span>

        <div class="line"></div>

    </div>
    <!-- ================= DEPOT ================= -->

<mat-radio-group
  [(ngModel)]="deliveryMode"
  class="delivery-radio-group custom-radio">

  <mat-radio-button
    value="POINT_OF_SALE"
    class="delivery-option">

    <div class="option-content">
      <span class="option-title">
        ENLÈVEMENT DÉPÔT
      </span>
    </div>

  </mat-radio-button>

</mat-radio-group>

    <!-- Bloc enlèvement dépôt : visible SEULEMENT si "pickup" est choisi -->
    <div *ngIf="deliveryMode === 'POINT_OF_SALE'">
      <span class="s_title">Retirez gratuitement votre commande directement dans notre dépôt</span>

      <div *ngIf="parameter$ | async as parameter">
        <div fxLayout="row" fxLayoutGap="16px" fxLayout.lt-md="column wrap">

          <!-- Bloc Contact (téléphone + email) -->
          <div class="card" fxFlex="55" fxFlex.lt-md="100" fxLayout="column" fxLayoutGap="16px">
            <span style="font-weight: 600;">CONTACT</span>

            <div fxLayout="column" fxLayoutGap="8px" style="margin-top: 8px;">
              <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
                <div
                  class="global-icon"
                  fxFlex="24px"
                  style="height: 24px; width: 24px;"
                  [ngStyle]="{
                    'mask-image': 'url(assets/icons/call.svg)',
                    '-webkit-mask-image': 'url(assets/icons/call.svg)'
                  }"
                  alt="phone"
                ></div>
                <a
                  href="tel:{{ parameter.phoneNumber }}"
                  style="color: var(--true-grey-900); text-decoration: none;"
                >
                  {{ parameter.phoneNumber }}
                </a>
              </div>

              <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
                <div
                  class="global-icon"
                  fxFlex="24px"
                  style="height: 24px; width: 24px;"
                  [ngStyle]="{
                    'mask-image': 'url(assets/icons/email.svg)',
                    '-webkit-mask-image': 'url(assets/icons/email.svg)'
                  }"
                  alt="email"
                ></div>
                <a
                  href="mailto:{{ parameter.supportEmail }}"
                  style="color: var(--true-grey-900); text-decoration: none;"
                >
                  {{ parameter.supportEmail }}
                </a>
              </div>
            </div>
          </div>
          <!-- fin Bloc Contact -->

          <!-- Bloc Adresse -->
          <div class="card" fxFlex fxLayout="column" fxLayoutGap="16px">
            <span style="font-weight: 600;">ADRESSE</span>

            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px" style="margin-top: 8px;">
              <div
                class="global-icon"
                fxFlex="24px"
                style="height: 24px; width: 24px;"
                [ngStyle]="{
                  'mask-image': 'url(assets/icons/location.svg)',
                  '-webkit-mask-image': 'url(assets/icons/location.svg)'
                }"
                alt="address"
              ></div>
              <a
                *ngIf="parameter.address && parameter.mapsSharedLink"
                [href]="parameter.mapsSharedLink"
                target="_blank"
                style="color: var(--true-grey-900); text-decoration: none;"
              >
                {{ parameter.address }}
              </a>
            </div>
          </div>
          <!-- fin Bloc Adresse -->

        </div>
      </div>
    </div>
  </div>

  <div gdArea="controls" fxLayout fxLayoutGap="16px" fxLayoutGap.xs="8px" style="margin-top: 10px">
    <button mat-button class="strocked-btn" (click)="close()" fxFlex="">
      ANNULER
    </button>

    <button
      *ngIf="!isVirtual"
      mat-button
      class="next-btn"
      (click)="next()"
      [disabled]="loading"
      fxFlex=""
      [ngClass]="{
        'btn-disabled':
          message.value === '' ||
          (deliveryMode === 'DELIVERY_ADDRESS' && addAddressForm.invalid) ||
          (deliveryMode === 'DELIVERY_ADDRESS' && !isCountry)
      }"
    >
      <mat-spinner *ngIf="loading" diameter="30"></mat-spinner>
      <span *ngIf="!loading">
        ENVOYER
      </span>
    </button>

    <button
      *ngIf="isVirtual"
      mat-button
      class="next-btn"
      (click)="next()"
      fxFlex=""
      [ngClass]="{
        'btn-disabled':
          message.value === ''
      }"
    >
      ENVOYER
    </button>
  </div>
</div>